import { useMemo } from 'react';

import { useHasEligibleWorkspaces } from './useHasEligibleWorkspaces';

export const useHasNoPaidWorkspaces = () => {
  const { isEligible: hasEligibleStandardOrPremiumWorkspaces } =
    useHasEligibleWorkspaces({
      entitlementRequired: 'standardOrPremium',
    });
  const { isEligible: hasEligibleEnterpriseWorkspaces } =
    useHasEligibleWorkspaces({
      entitlementRequired: 'enterprise',
    });
  const hasNoPaidWorkspaces = useMemo(
    () =>
      !hasEligibleStandardOrPremiumWorkspaces &&
      !hasEligibleEnterpriseWorkspaces,
    [hasEligibleStandardOrPremiumWorkspaces, hasEligibleEnterpriseWorkspaces],
  );
  return {
    hasNoPaidWorkspaces,
  };
};
